<template>
  <div class="more-commands">
    <div class="more-commands_title">
      <span :class="icons.FileConfig"> </span>
      <span> {{ $t("processDesign.accessToolbar.moreCommands.title") }} </span>
    </div>
    <div class="more-commands_box">
      <div class="more-commands_left-box_wrapper">
        <div class="more-commands_left-box_wrapper--source">
          {{ $t("processDesign.accessToolbar.moreCommands.source") }}
        </div>
        <div
          id="sourceBox"
          ref="sourceBox"
          data-test-id="source-box"
          class="more-commands_left-box"
          @dragover="dragOver($event, 'sourceBox')"
          @drop="drop($event, 'sourceBox')"
        >
          <div
            class="more-commands_left-box--up"
            @click="moveItemsDown('source')"
            @mouseenter="moveItemsDown('source')"
          >
            <i class="icon-menu-up"></i>
          </div>
          <div
            v-for="id in sourceItems"
            :key="id"
            class="command-item"
            :draggable="true"
            :class="{ active: activeId === id }"
            :data-test-id="`${accessToolbarComponents[id]?.name}-command-item`"
            @click="activeId = id"
            @dragstart="dragStart($event, id, 'sourceItem')"
            @dragend="resetDropIndicator"
          >
            <span :class="accessToolbarComponents[id]?.icon"></span>
            {{ accessToolbarComponents[id]?.title }}
          </div>
        </div>
        <div class="more-commands_left-box--down" @click="moveItemsUp('source')" @mouseenter="moveItemsUp('source')">
          <i class="icon-menu-down"></i>
        </div>
      </div>
      <div class="more-commands_right-box_wrapper">
        <span class="more-commands_left-box_wrapper--target">{{
          $t("processDesign.accessToolbar.moreCommands.target")
        }}</span>

        <div
          id="targetBox"
          ref="targetBox"
          data-test-id="target-box"
          class="more-commands_right-box"
          @dragover="dragOver($event, 'targetBox')"
          @drop="drop($event, 'targetBox')"
        >
          <div
            class="more-commands_left-box--up"
            @click="moveItemsDown('target')"
            @mouseenter="moveItemsDown('target')"
          >
            <i class="icon-menu-up"></i>
          </div>
          <div
            v-for="(id, index) in targetItems"
            :key="id"
            class="command-item"
            :draggable="true"
            :class="{ active: activeId === id }"
            :data-test-id="`${accessToolbarComponents[id]?.name}-command-item`"
            @click="activeId = id"
            @dragstart="dragStart($event, id, 'targetItem')"
            @dragend="resetDropIndicator"
          >
            <span :class="accessToolbarComponents[id]?.icon"></span>
            {{ accessToolbarComponents[id]?.title }}
            <span class="command-item_order">{{ formatNumber(index + 1) }}</span>
            <horizontal-drop-indicator v-if="dropIndicator.id === id" />
          </div>
        </div>
        <div class="more-commands_left-box--down" @click="moveItemsUp('target')" @mouseenter="moveItemsUp('target')">
          <i class="icon-menu-down"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { icons } from "../../../utils/icons";
import { arrayMoveMutable, calculateTargetIndex } from "../../../utils/array"; //
import { HotkeyScopes, Positions, Direction } from "../../../utils/constants";
import HorizontalDropIndicator from "../HorizontalDropIndicator.vue";
import hotkeys from "hotkeys-js";
export default {
  components: {
    HorizontalDropIndicator,
  },
  data() {
    return {
      icons: icons,
      activeId: null,
      sourceItems: [],
      targetItems: [],
      prevScope: null,
    };
  },
  computed: {
    selectedTools() {
      return this.$store.state.preferences.allPreferences.accessToolbar ?? [];
    },
    accessToolbarComponents() {
      return this.$store.state.preferences.accessToolbarComponents;
    },
    allComponentIds() {
      return Object.keys(this.accessToolbarComponents).map((key) => parseInt(key, 10));
    },
    sourceComponentIds() {
      return this.allComponentIds.filter((value) => !this.selectedTools.includes(value));
    },
    dropIndicator() {
      return this.$store.state.pdesign.dropIndicator;
    },
  },
  watch: {
    sourceComponentIds(newValue, oldValue) {
      this.sourceItems = [...newValue];
      this.sortSourceItems();
    },
    selectedTools(newValue, oldValue) {
      this.targetItems = [...newValue];
    },
  },
  mounted() {
    this.sourceItems = [...this.sourceComponentIds];
    this.targetItems = [...this.selectedTools];
    this.sortSourceItems();
    this.prevScope = hotkeys.getScope();
    this.$store.dispatch("setScope", HotkeyScopes.MoreCommands);

    hotkeys(
      "up, down, left, right, ctrl+up,cmd+up, ctrl+down,cmd+down, ctrl+left,cmd+left, ctrl+right,cmd+right",
      HotkeyScopes.MoreCommands,
      (event, handler) => {
        event.preventDefault();
        switch (handler.key) {
          case "up":
            this.go(Direction.Up);
            break;
          case "down":
            this.go(Direction.Down);
            break;
          case "left":
            this.go(Direction.Left);
            break;
          case "right":
            this.go(Direction.Right);
            break;
          case "ctrl+up":
          case "cmd+up":
            this.move(Direction.Up);
            break;
          case "ctrl+down":
          case "cmd+down":
            this.move(Direction.Down);
            break;
          case "ctrl+left":
          case "cmd+left":
            this.move(Direction.Left);
            break;
          case "ctrl+right":
          case "cmd+right":
            this.move(Direction.Right);
            break;
        }
      }
    );
  },
  beforeUnmount() {
    hotkeys.unbind(
      "up, down, left, right, ctrl+up,cmd+up, ctrl+down,cmd+down, ctrl+left,cmd+left, ctrl+right,cmd+right",
      HotkeyScopes.MoreCommands
    );
    this.$store.dispatch("setScope", this.prevScope);
  },
  methods: {
    moveItemsUp(type) {
      const container = type == "source" ? this.$refs.sourceBox : this.$refs.targetBox;
      container.scrollBy({
        top: 165,
        behavior: "smooth",
      });
    },

    moveItemsDown(type) {
      const container = type == "source" ? this.$refs.sourceBox : this.$refs.targetBox;
      container.scrollBy({
        top: -165,
        behavior: "smooth",
      });
    },
    dragStart(e, id, itemType) {
      e.dataTransfer.setData("id", id);
      e.dataTransfer.setData(itemType, true);
      e.dataTransfer.effectAllowed = "move";
    },

    async drop(e, boxId) {
      const id = e.dataTransfer.getData("id");
      const dropIndicator = this.dropIndicator;

      if (e.dataTransfer.getData("sourceItem") && boxId === "targetBox") {
        const fromIndex = this.targetItems.length;
        const tempTargetIndex = this.targetItems.indexOf(dropIndicator.id);

        const targetIndex = calculateTargetIndex(this.targetItems, fromIndex, tempTargetIndex, dropIndicator.position);
        this.targetItems.splice(targetIndex, 0, +id);
      }
      if (e.dataTransfer.getData("targetItem")) {
        if (boxId === "sourceBox") {
          this.targetItems = this.targetItems.filter((x) => x !== +id);
        } else {
          const fromIndex = this.targetItems.indexOf(+id);
          const tempTargetIndex = this.targetItems.indexOf(dropIndicator.id);

          const targetIndex = calculateTargetIndex(
            this.targetItems,
            fromIndex,
            tempTargetIndex,
            dropIndicator.position
          );

          arrayMoveMutable(this.targetItems, fromIndex, targetIndex);
        }
      }

      this.sortSourceItems();
      this.save();
    },
    dragOver(e, boxId) {
      e.preventDefault();
      const box = document.querySelector(`#${boxId}`).getBoundingClientRect();

      // hide the drop indicator while dragging items to the source box.
      if (boxId === "sourceBox") return this.resetDropIndicator();

      const startPoint = box.y + 11.2; // 0.7rem = 11.2px which is the padding of the boxes.
      let sum = 0;
      for (let index = 0; index < this.targetItems.length; index++) {
        sum += 48; // 40px is height of the item and 8px is the gap between the items.
        if (sum > e.clientY - startPoint || index === this.targetItems.length - 1) {
          const position = sum - (e.clientY - startPoint) > 20 ? Positions.Before : Positions.After;
          this.$store.dispatch("pdesign/setDropIndicator", { id: this.targetItems[index], position: position });
          break;
        }
      }
    },

    resetDropIndicator() {
      this.$store.dispatch("pdesign/resetDropIndicator");
    },
    save() {
      const key = "accessToolbar";
      const value = [...this.targetItems];
      this.$store.dispatch("preferences/update", { key, value });
    },
    formatNumber(number) {
      return number < 10 ? `0${number}` : number;
    },
    sortSourceItems() {
      this.sourceItems.sort((a, b) => {
        const nameA = this.accessToolbarComponents[a]?.title?.toLowerCase();
        const nameB = this.accessToolbarComponents[b]?.title?.toLowerCase();

        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      });
    },

    move(direction) {
      if (!this.activeId) return;
      if (this.targetItems.includes(this.activeId)) {
        const fromIndex = this.targetItems.indexOf(this.activeId);
        if (direction === Direction.Up && fromIndex !== 0) {
          arrayMoveMutable(this.targetItems, fromIndex, fromIndex - 1);
        }
        if (direction === Direction.Down && fromIndex !== this.targetItems.length - 1) {
          arrayMoveMutable(this.targetItems, fromIndex, fromIndex + 1);
        }
      }
      if (direction === Direction.Left) {
        this.targetItems = this.targetItems.filter((x) => x !== this.activeId);
      }
      if (direction === Direction.Right) {
        this.targetItems = this.targetItems.filter((x) => x !== this.activeId);
        this.targetItems.push(this.activeId);
      }
      this.save();
    },
    go(direction) {
      const boxId = this.targetItems.includes(this.activeId) ? "targetBox" : "sourceBox";
      const array = this.targetItems.includes(this.activeId) ? this.targetItems : this.sourceItems;
      const index = array.indexOf(this.activeId);
      if (direction === Direction.Up && index !== 0) {
        this.activeId = array[index - 1];
        this.scroll(boxId);
      }
      if (direction === Direction.Down && index !== array.length - 1) {
        this.activeId = array[index + 1];
        this.scroll(boxId);
      }
      if (direction === Direction.Left) {
        this.activeId = this.sourceItems[0];
      }
      if (direction === Direction.Right) {
        this.activeId = this.targetItems[0];
      }
    },
    scroll(boxId) {
      const activeItem = document.querySelector(".active")?.getBoundingClientRect();
      if (!activeItem) return;
      const container = document.querySelector(`#${boxId}`);
      const containerBound = container.getBoundingClientRect();

      if (activeItem.top - 15 < containerBound.top) {
        let scrollTop = Math.ceil(container.scrollTop - 70.6);
        container.scrollTop = scrollTop;
      }
      if (activeItem.bottom + 15 > containerBound.bottom) {
        let scrollTop = Math.ceil(container.scrollTop + 70.6);
        container.scrollTop = scrollTop;
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../../assets/styles/variables.less";

.more-commands {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 1rem 0;
  padding-left: 5rem;
  background-color: #f8f8fb;
  border-radius: 10px;

  &_title {
    align-self: start;
    margin-bottom: 1rem;
    font-size: 16px;
    padding: 0.5rem 0;
  }
  &_box {
    display: flex;
    justify-content: center;
    gap: 3rem;
    height: 45rem;
    overflow: auto;
  }
  &_left-box_wrapper,
  &_right-box_wrapper {
    display: flex;
    flex-direction: column;
    color: @kk-color-primary-blue;

    &--source,
    &--target {
      padding: 10px;
      border-radius: 8px 8px 0px 0px;
      text-align: center;
      width: 26%;
      background-color: @kk-color-background;
    }
  }
  &_left-box,
  &_right-box {
    width: 25rem;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 0 0.7rem;
    background-color: @kk-color-background;
    border-radius: 0px 8px 0px 0px;
    overflow: auto;

    /* Hide the scrollbar for Internet Explorer, Edge and Firefox */
    -ms-overflow-style: none; /* Internet Explorer and Edge */
    scrollbar-width: none; /* Firefox */

    /* Hide the scrollbar for Chrome, Safari and Opera */
    &::-webkit-scrollbar {
      display: none;
    }

    &--up,
    &--down {
      font-size: 1.7rem;
      background-color: @kk-color-background;
      text-align: center;
    }

    &--up {
      position: sticky;
      left: 0;
      right: 0;
      top: 0px;
      z-index: 10;
    }

    &--down {
      border-radius: 0px 0px 8px 8px;
    }

    .command-item {
      position: relative;
      height: 2.5rem;
      padding: 0.5rem 1rem;
      display: flex;
      align-items: center;
      gap: 0.5rem;
      border-radius: 8px;
      box-shadow: 0px 4px 4px 0px rgba(8, 50, 119, 0.09);
      cursor: grab;
      background-color: @kk-color-white;
      &:hover {
        background-color: @kk-color-primary-blue;
        color: @kk-color-white;
      }
      &_order {
        position: absolute;
        right: 1rem;
      }
    }
    .active {
      background-color: @kk-color-primary-blue;
      color: @kk-color-white;
    }
  }
}
</style>
